import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { EditArt } from '../../../_interfaces/EditArt';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { TicketEditService } from '../../../_provider/ticket-edit.service';
import { TransferService } from '../../../_provider/transfer.service';

@Component({
  selector: 'app-art-popover',
  templateUrl: './art-popover.page.html',
  styleUrls: ['./art-popover.page.scss'],
})
export class ArtPopoverPage implements OnInit {

  @ViewChild('search', {static: true}) searchElement: ElementRef;

  public selectedItem: number = 0
  public filterValue: string = ""
  public type: "modal" | "popover"

  public _filter: EditArt[] = []

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      this.select(this._filter[index])
    }
  }

  constructor(
    public ticketEditSrv: TicketEditService,
    private transfer: TransferService,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService,
    private popoverCtrl: PopoverController
  ) {
    this._filter = this.ticketEditSrv.ticketArts

  }

  public get filter(): EditArt[]{
    return this._filter
  }

  ngOnInit() {
    this.type = this.navParams.get<"modal" | "popover">("type")
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 1000);
  }

  select(art: EditArt){
    this.transfer.setVALUE(art)
    if(this.type == "popover") this.popoverCtrl.dismiss()
    else this.modalCtrl.dismiss()
  }

  setFilter(event: KeyboardEvent): void{
    this._filter = this.ticketEditSrv.ticketArts.filter((art: EditArt)=>{
      return art.description.toLowerCase().includes(this.filterValue.toLowerCase())
    });
    if(event.key != "ArrowUp" && event.key != "ArrowDown" && event.key != "Enter")
    this.selectedItem = 0
  }

  public keydown(event: KeyboardEvent){
    switch(event.key){
      case "ArrowUp":
        if(this.selectedItem > 0)
        this.selectedItem--
        break
      case "ArrowDown":
        if(this.selectedItem < this._filter.length - 1)
        this.selectedItem++
        break
    }
  }

  public keyup(event: KeyboardEvent){
    if(event.key == "Enter")
    this.select(this._filter[this.selectedItem])
  }

  
  public async close(){
    await this.modalCtrl.dismiss()
  }

}
